import styled from 'styled-components';
import { Col } from 'antd';
import getColor from 'utils/getColor';

const InnerContainer = styled.div`
  ${({ $justifyDesktop, $justifyMobile }) => {
    if ($justifyDesktop || $justifyMobile) {
      return `
        justify-content: ${$justifyDesktop || $justifyMobile};
        align-items: ${$justifyDesktop || $justifyMobile};
        display: flex;
        flex-direction: column;
        height: 100% !important;
      `;
    }
  }}
  ${({ $backgroundColor, $backgroundImage, $customBackgroundDesktop, $customBackgroundMobile }) => {
    if (
      $backgroundColor ||
      $backgroundImage ||
      $customBackgroundDesktop ||
      $customBackgroundMobile
    ) {
      return `
        background: ${
          $backgroundImage
            ? `url(${$backgroundImage})`
            : $backgroundColor || $customBackgroundDesktop || $customBackgroundMobile || null
        };
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        height: 100%;
      `;
    }
  }}
  ${({ $horizontalContentFlowDesktop, $alignDesktop, $alignMobile }) => {
    if ($horizontalContentFlowDesktop) {
      return `
        display: flex;
        flex-direction: row;
        align-Items: ${$alignDesktop || $alignMobile || 'center'};
      `;
    }
  }}
  width: 100%;
  margin: ${({ $marginMobile, $marginDesktop }) => $marginDesktop || $marginMobile};
  padding: ${({ $paddingMobile, $paddingDesktop }) => $paddingDesktop || $paddingMobile};
  border-width: ${({ $border }) => $border};
  border-color: ${({ $border, $borderColor }) => {
    if ($border) {
      return getColor($borderColor) || 'black';
    }
  }};
  border-style: ${({ $border }) => $border && 'solid'};
  box-shadow: ${({ $shadow }) => {
    if ($shadow === 'Small') {
      return '0px 3px 10px rgba(11, 26, 33, 0.08);';
    } else if ($shadow === 'Medium') {
      return '0px 15px 40px rgba(11, 26, 33, 0.1);';
    } else if ($shadow === 'Large') {
      return ' 0px 30px 60px rgba(11, 26, 33, 0.15);';
    }
  }};
  order: ${({ $orderDesktop }) => $orderDesktop};
  position: relative;

  .hideDesktop {
    display: none;
  }

  @media (max-width: 576px) {
    ${({ $backgroundColor, $backgroundImage, $customBackgroundMobile }) => {
      if ($backgroundColor || $backgroundImage || $customBackgroundMobile) {
        return `
          background: ${
            $backgroundImage
              ? `url(${$backgroundImage})`
              : $backgroundColor || $customBackgroundMobile || null
          };
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          height: 100%;
        `;
      }
    }}
    ${({ $$alignMobile, $justifyMobile }) => {
      if ($justifyMobile) {
        return `
        justify-content: ${$justifyMobile};
        align-items: ${$$alignMobile};
        display: flex;
        flex-direction: ${$justifyMobile};
        height: 100% !important;
      `;
      }
    }}
    ${({ $horizontalContentFlowMobile, $alignMobile }) => {
      if ($horizontalContentFlowMobile) {
        return `
      display: flex;
      flex-direction: row;
      align-Items: ${$alignMobile || 'center'}
    `;
      }
    }}
    height: ${({ $heightMobile }) => $heightMobile && `${$heightMobile} !important`};
    margin: ${({ $marginMobile }) => $marginMobile};
    order: ${({ $orderMobile }) => $orderMobile};
    padding: ${({ $paddingMobile }) => $paddingMobile};


    .hideDesktop {
      display: block;
    }

    .hideMobile {
      display: none;
    }
  }
`;

const StyledColumn = styled(Col)`
  ${({ $customCss }) => $customCss};
  height: ${({ $heightMobile, $heightDesktop }) => $heightDesktop || $heightMobile};
  order: ${({ $orderDesktop }) => $orderDesktop};

  @media (max-width: 576px) {
    height: ${({ $heightMobile }) => $heightMobile};
    order: ${({ $orderMobile }) => $orderMobile};
  }
`;

const WebsiteImageContainer = styled.div`
  margin: ${({ $justifyMobile, $justifyDesktop }) => {
    if ($justifyMobile || $justifyDesktop === 'flex-start') {
      return 'inherit';
    } else {
      return '0 auto';
    }
  }};
  height: ${({ $heightDesktop }) => $heightDesktop && `${$heightDesktop}px`};
  width: ${({ widthDesktop }) => widthDesktop};
  max-width: 100%;

  @media (max-width: 576px) {
    height: ${({ $heightMobile }) => $heightMobile && `${$heightMobile}px`};
    width: ${({ widthMobile }) => widthMobile};
  }
`;

const CardBlockContainer = styled.div`
  .section-layout--inner-container {
    padding: 0 !important;
  }
`;

export { InnerContainer, CardBlockContainer, StyledColumn, WebsiteImageContainer };
